import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, ExamBlockPlaceHolder, NodePOSTApi, NodePOSTApiResetEmail } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';
import UploadAnswer from './UploadAnswer';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import "./courses.css"
const slug = {
  "ubt": "UBT",
  "cbt-chemical": "CBT CHEMICAL",
  "cbt-electronics-electricity": "CBT ELECTRONIC ELECTRCITY",
  "cbt-food-related": "CBT FOOD RELATED",
  "cbt-mechinery-molding": "CBT MACHINERY,MOLDING",
  "cbt-metal": "CBT METAL",
  "cbt-pulp-paper-wood": "CBT PULP PAPER WOOD",
  "cbt-rubber": "CBT RUBBER",
  "cbt-textile-sewing": "CBT TEXTILE SEWING"
}
export default function AllMyExamList() {
  const [AllExamList1, setAllExamList1] = React.useState([]);
  const [AllExamListUnavailable, setAllExamListUnavailable] = React.useState([]);
  const [reload, setReload] = React.useState(true)
  const [newDeviceDetected, setNewDeviceDetected] = React.useState(false)
  const [pagesLength, setPagesLength] = React.useState("1");
  const [choose, setChoose] = React.useState(0);
  const [userID, setUserID] = React.useState("");
  const [OTP, setOTP] = React.useState("");
  const [OTPError, setOTPError] = React.useState(false);
  const [OTPCodeStore, setOTPCodeStore] = React.useState("");
  const [Email, setEmail] = React.useState("");
  const [Name, setName] = React.useState("");
  const [pages, setPages] = React.useState(1);
  const dispatch = useDispatch()
  const [usersData, setUsersData] = React.useState({ meta: { number_of_exams: "0" } });
  const LoginState = useSelector((state) => state.LoginState);
  const getDeviceFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId; // unique & stable
  };
  const fetchExam = (verifiedExamList) => {
    setReload(true)
    console.log("aaa")
    var page_query = {}
    AdsGETApiAuth({
      per_page: 1000,
      order: "asc",
      _fields: "id,title,meta,slug",
      ...page_query
    }, slugs.db_slug_batch)
      .then((res) => {
        // setAllExamList(res.data)
        const examList = res.data
        var verified = [];
        var unverified = [];
        for (let i = 0; i < examList.length; i++) {
          if (verifiedExamList.filter(a => a.course_id == examList[i].id).length !== 0)
            verified.push(examList[i])
          else
            unverified.push(examList[i])
          setAllExamList1(verified)
        }
        setReload(false)
      })
      .catch(err => {
        console.log(err)
        // console.log(err.response.data)
        setReload(false)
        if (err.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
  }
  let myarray = []
  for (let i = 0; i < pagesLength; i++)
    myarray.push(
      <div key={i} style={{ margin: "3px" }}>
        <button onClick={() => {
          setPages(i + 1)
          setAllExamList1([])
          fetchExam(setAllExamList1, { page: i + 1, per_page: 100, order: "asc" })
        }}
          style={{ border: "0", padding: "7px", backgroundColor: pages == i + 1 ? "#0d02a6" : "#f00", color: "#fff", borderRadius: "5px" }}
        >
          {i + 1}
        </button>
      </div>
    )
  const location = useLocation()
  useEffect(() => {
    GetAllData()
  }, [])

  const GetAllData = () => {
    setReload(true)
    AdsGETApiAuth({
      status: "any",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": LoginState.userID,
      "filter[meta_query][1][compare]": "=",
      _fields: "meta,id"
    }, "user_data")
      .then((response) => {
        if (response.data.length !== 0) {
          setUsersData(response.data[0])
          var deviceid = response.data[0].meta.device_id
          setName(response.data[0].meta.user_name)
          setEmail(response.data[0].meta.user_email)
          setUserID(response.data[0].id)
          getDeviceFingerprint().then(fingerprint => {
            if (deviceid == fingerprint || deviceid == "") {
              var verifiedExamListCache = response.data[0].meta.verified_course_list
              var verifiedExamList;
              if (verifiedExamListCache == "")
                verifiedExamList = [];
              else
                verifiedExamList = JSON.parse(verifiedExamListCache)
              var attendance = []
              var date = new Date()
              var today = date.toLocaleDateString()

              if (response.data[0].meta.attendance == "") {
                attendance.push(today)
                AdsPUTApi({
                  meta: {
                    attendance: `${JSON.stringify(attendance)}`,
                    device_id: `${fingerprint}`
                  }
                }, slugs.db_slug_user_data, response.data[0].id)
                  .then(res => {
                    fetchExam(verifiedExamList)
                  })
              }
              else {
                attendance = JSON.parse(response.data[0].meta.attendance)
                if (attendance.filter(a => a == today).length == 0) {
                  attendance.push(today)
                  AdsPUTApi({
                    meta: {
                      attendance: `${JSON.stringify(attendance)}`,
                      device_id: `${fingerprint}`
                    }
                  }, slugs.db_slug_user_data, response.data[0].id)
                    .then(res => {
                      fetchExam(verifiedExamList)
                    })
                }
                else {
                  if (deviceid == "")
                    AdsPUTApi({
                      meta: {
                        device_id: `${fingerprint}`
                      }
                    }, slugs.db_slug_user_data, response.data[0].id)
                      .then(res => {
                        fetchExam(verifiedExamList)
                      })
                  else
                    fetchExam(verifiedExamList)
                }
              }
            }
            else {
              setNewDeviceDetected(true)
            }
          })
        }
        else
          dispatch(logout())
      })
      .catch(e => {
        if (e.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
  }

  const maskEmail = (email) => {
    if (!email || !email.includes("@")) return "";

    const [username, domain] = email.split("@");

    if (username.length <= 4) {
      return `${username.charAt(0)}****@${domain}`;
    }

    return `${username.slice(0, 2)}********${username.slice(-2)}@${domain}`;
  };
  return (
    <div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mt-3">
          <div className="row" style={{ margin: "10px" }}>
            <h2>All Courses</h2>
            {AllExamList1.map((item, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-12 center" style={{ padding: "0 5px" }}>
                <ExamBlock item={item} examSlug={slugs.start_course} />
              </div>
            ))}
          </div>
          {AllExamListUnavailable.length != 0 &&
            <div className="row" style={{ margin: "10px" }}>
              <h2>Unavailable Exams</h2>
              {AllExamListUnavailable.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-4 col-12 center" style={{ padding: "0 5px" }}>
                  <ExamBlock item={item} examSlug={slugs.start_course} />
                </div>
              ))}
            </div>
          }

          {pagesLength !== "1" &&
            <div className="" style={{ display: 'flex', flexDirection: 'row', margin: 10 }}>
              {myarray}
            </div>
          }
          {/* <div className="row">
            <div className="form-view mt-3">

              <UploadAnswer setReload={setReload} />
            </div>
          </div> */}
        </div>
      </div>

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {newDeviceDetected &&
        <div className="modal"
          onClick={() => {
          }}
        >
          <div>
            <div className="row " style={{ minHeight: "10vh", marginTop: "10vh" }}>
              <div className="col-sm-3 col-1"></div>
              <div className="col-sm-6 col-10 pb-5  bg-white  shadow">
                {choose == 0 &&
                  <>
                    <div className="device-popup-overlay">
                      <div className="device-popup">
                        <div className="warning-icon">!</div>

                        <h2 className="device-popup-title">Warning</h2>

                        <p className="device-popup-message">
                          तपाईंको Account अर्को Device मा Login भएको छ।
                          <br />
                          एक समयमा एउटा Device मा मात्र Login गर्न सकिन्छ।
                          <br />
                          कृपया Logout गर्नुहोस् वा यो Device प्रयोग गर्न{" "}
                          <strong>Reset Device</strong> गर्नुहोस्।
                          <br />
                          Reset Device गर्दा OTP तपाईंको registered Email
                          <br />

                          <span className="masked-email">
                            {maskEmail(Email)}
                          </span>

                          <br />
                          मा पठाइनेछ।
                        </p>

                        <div className="device-popup-note">
                          OTP verify भएपछि पुरानो Device automatically Logout हुनेछ।
                        </div>

                        <div className="device-popup-actions">
                          <button className="device-popup-btn logout-btn"
                            onClick={() => {
                              dispatch(logout())
                            }}
                          >
                            Logout
                          </button>

                          <button className="device-popup-btn reset-btn"
                            onClick={() => {
                              function generateRandomNumber() {
                                var minm = 100000;
                                var maxm = 999999;
                                return Math.floor(Math.random() * (maxm - minm + 1)) + minm;
                              }
                              const OTPCode = generateRandomNumber()
                              setOTPCodeStore(OTPCode)
                              NodePOSTApiResetEmail({
                                email: `${Email}`,
                                subject: `Reset Device ${OTPCode} Loksewa Network`,
                                body: `
नमस्कार ${Name},
<br/>
<br/>
तपाईंको खातासँग जोडिएको Device Reset गर्न अनुरोध प्राप्त भएको छ।
<br/>
Device Reset प्रक्रिया पूरा गर्न तल दिइएको OTP कोड प्रयोग गर्नुहोस्:
<br/>
<br/>
OTP कोड: <strong>${OTPCode}</strong>
<br/>
<br/>
यदि तपाईंले Device गर्न अनुरोध गर्नुभएको होइन भने, यो कोड कसैसँग साझा नगर्नुहोस् र यो इमेललाई बेवास्ता गर्नुहोस्।
<br/>
<br/>

सुरक्षाका लागि फोन, इमेल वा अन्य माध्यमबाट तपाईंको OTP कोड माग्ने छैन।
<br/>
<br/>

धन्यवाद,
<br/>
Loksewa Network- NEA
<br/>
Bagbazar, Kathmandu
`
                              }, "send_email")
                                .then(res => {
                                })
                              setChoose(1)

                            }}
                          >
                            Send OTP to Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
                {choose == 1 &&
                  <>
                    {/* <div className="p-5">
                      <div>Please enter the 6 digits otp received in your registered email?</div>
                      <div>
                        <input className='input-common'
                          placeholder='OTP'
                          onChange={(event) => {
                            setOTP(event.target.value)
                          }}
                        />
                      </div>
                      <div style={{ display: 'flex', cursor: 'pointer' }} className="center">
                        <div className="sign-in-button-2 col-4">
                          Logout
                        </div>
                        <div className="sign-in-button-1 col-4 mx-1">
                          Reset Device
                        </div>
                      </div>
                    </div> */}
                    <div className="otp-overlay">
                      <div className="otp-modal">

                        <h2 className="otp-title">
                          Please enter the 6 digits OTP received in your
                          registered email?
                        </h2>

                        <input
                          type="text"
                          className="otp-input"
                          placeholder="OTP"
                          maxLength={6}
                          value={OTP}
                          onChange={(event) => {
                            setOTP(event.target.value)
                            setOTPError(false)
                          }}

                        />
                        {/* {OTPCodeStore} */}
                        <p className="otp-error">
                          {OTPError &&
                            "Incorrect OTP. Please try again."
                          }
                        </p>

                        <div className="otp-buttons">
                          <button className="logout-btn"
                            onClick={() => {
                              dispatch(logout())
                            }}
                          >
                            Logout
                          </button>

                          <button className="reset-btn"
                            onClick={() => {
                              if (OTP != OTPCodeStore)
                                setOTPError(true)
                              else {
                                setReload(true)
                                setNewDeviceDetected(false)
                                AdsPUTApi({
                                  meta: {
                                    device_id: ``
                                  }
                                }, slugs.db_slug_user_data, userID)
                                  .then(res => {
                                    GetAllData()
                                  })
                              }
                            }}
                          >
                            Reset Device
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

const ExamBlock = ({ item, examSlug }) => {
 const location = useLocation();
  return (
    <div className="course-card">
  <div className="course-image-wrapper">
    <img
      className="course-image"
      src={
        item.meta.featured_image !== ""
          ? item.meta.featured_image
          : ExamBlockPlaceHolder
      }
      alt={item.title.rendered}
    />
  </div>

  <div className="course-title">
    {item.title.rendered}
  </div>

  <div className="course-actions">
    <Link
      className="course-button course-open-button"
      to={`${examSlug}/${item.slug}`}
    >
      Open Course
    </Link>

    {item.meta.zoom_link !== "" && (
      <a
        className="course-button course-live-button"
        href={item.meta.zoom_link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="zoom-icon"
          src="https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/Screenshot-2025-09-05-at-10.00.32.png"
          alt=""
        />
        Live Class
      </a>
    )}
  </div>
</div>
  )

}


const ExamBlock2 = ({ item, examSlug }) => {
  const location = useLocation();
  return (
    <div style={{
      padding: "5px", margin: "5px 0px", border: "1.5px solid #bbb",
      borderRadius: "5px",
    }}>
      {item.meta.featured_image !== "" ?
        <img className="col-12" src={item.meta.featured_image}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
        :
        <img className="col-12"
          src={ExamBlockPlaceHolder}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
      }
      <br />
      <div>
        {item.title.rendered}&nbsp;
      </div>
      <div style={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
        <Link className="Link" style={{ border: "1px solid black", padding: "2px 10px", borderRadius: "10px" }}
          to={`${examSlug}/${item.slug}`}
        >
          <div style={{}}>
            Open Course
          </div>
        </Link>
      </div>
      {item.meta.zoom_link !== "" &&
        <div style={{ width: "100%", display: 'flex', justifyContent: 'center', marginTop: "10px" }}>
          <a className="Link" style={{ border: "1px solid black", padding: "2px 10px", borderRadius: "10px", }}
            href={item.meta.zoom_link}
          >
            <div style={{}}>
              {/* Join Live Class */}
              <img style={{ height: "20px" }}
                src='https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/Screenshot-2025-09-05-at-10.00.32.png'
              /> Live Class
            </div>
          </a>
        </div>
      }
    </div >
  )

}